export function resolveGroundServiceIds(grounds = [], service = {}) {
  const configuredServiceId = Number(service?.id);

  // Prefer exact id match to avoid mismatched routes.
  if (Number.isFinite(configuredServiceId) && configuredServiceId > 0) {
    for (const ground of grounds) {
      const matchingService = (ground?.services || []).find(
        (s) => Number(s?.id) === configuredServiceId
      );
      if (matchingService) {
        return {
          groundId: Number(ground.id),
          serviceId: Number(matchingService.id),
        };
      }
    }
  }

  // Fallback for legacy configs missing service ids.
  for (const ground of grounds) {
    const matchingService = (ground?.services || []).find(
      (s) => s?.name === service?.name && s?.type === service?.type
    );
    if (matchingService) {
      return {
        groundId: Number(ground.id),
        serviceId: Number(matchingService.id),
      };
    }
  }

  return null;
}

